function SearchModal(container) {
    this.el = container.querySelector('.jsSearchModal');
    this.closeBtnEl = this.el.querySelector('.jsSearchModalCloseBtn');
    this.formEl = this.el.querySelector('.jsSearchModalForm');

    // Event listeners
    document.body.addEventListener('click', e => {
        if (e.target.classList.contains('jsSearchModalTrigger')) {
            e.preventDefault();
            this.show();
        }
    });
    
    this.el.addEventListener('click', e => {
        if (e.target.classList.contains('jsCloseModal')) {
            e.preventDefault();
            this.hide();
        }
    });

    window.addEventListener('keyup', e => {
        if (e.key.toLowerCase() === 'escape') this.hide();
    });
}

SearchModal.prototype.show = function() {
    // Scroll to top
    vanillaSmoothie.scrollTo(0, { duration: 500, easing: 'easeInOutQuad' });

    // Animate
    gsap.timeline()
        .set(this.el, { opacity: 0 })
        .set(this.formEl, { y: -15, opacity: 0 })
        .add(_ => {
            this.el.classList.add('visible');
            this.formEl.querySelector('input').focus();
        })

        .to(this.el, { duration: 0.3, opacity: 1, ease: Power2.inOut })
        .to(this.formEl, { duration: 0.3, y: 0, opacity: 1, ease: Power2.inOut }, '-=0.3')
        
        .set([this.el, this.formEl], { clearProps: 'all' })
    ;
};

SearchModal.prototype.hide = function() {
    gsap.timeline()
        .to(this.el, { duration: 0.3, opacity: 0, ease: Power2.inOut })
        .to(this.formEl, { duration: 0.3, y: -15, opacity: 0, ease: Power2.inOut }, '-=0.3')
        
        .add(_ => this.el.classList.remove('visible'))
        .set([this.el, this.formEl], { clearProps: 'all' })
    ;
};